/**
 *   Lista kursów
 */

import React, { useEffect, useState } from 'react';
import CourseCard from './CourseCard';
import HeaderSmall from './HeaderSmall';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { connect } from 'react-redux';

import { getCourses, clearCurrentSectionId } from '../../redux/actions';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }
});

function Courses(props) {
  const classes = useStyles();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const courses = props.courses.filter(c => c.id !== 336);
    setCourses(courses);
    // eslint-disable-next-line
  }, [props.courses]);

  useEffect(() => {
    props.getCourses();
    props.clearCurrentSectionId();
    // eslint-disable-next-line
  }, []);

  const Course = (course, idx) => <CourseCard key={idx} course={course} />

  return (
    <>
      <HeaderSmall title="Kursy" />
      <div className={clsx('container', classes.container)} >
        {courses.map(Course)}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return { courses: state.courses }
}

export default connect(mapStateToProps, { getCourses, clearCurrentSectionId })(Courses);